import React from 'react';

import {StateSwitchComponent} from './StateSwitchComponent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';



class Header extends StateSwitchComponent{
  handleTabChange = (event, newTabIndex) => {
    if (this.mainSiteComponent.state.view === 'results') {
      return;
    }
    if (newTabIndex === 0) {
      this.switchToSearch();
    } else {
      this.switchToTable();
    }
  };

  render() {
    const view = this.mainSiteComponent.state.view;
    const tabIndex = view === 'table' ? 1 : view === 'search' ? 0 : false;
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} aria-label="basic tabs example" variant="fullWidth"
          onChange={this.handleTabChange} >
            <Tab label="Search" />
            <Tab label="Table" />
          </Tabs>
        </Box>
      </Box>
    );
  }
}

export default Header;
